export const GET_TAG = "GET_TAG";
export const CREATE_TAG = "CREATE_TAG";
export const EDIT_TAG = "EDIT_TAG";
export const DELETE_TAG = "DELETE_TAG";


export const OPEN_TAG_DIALOG = "OPEN_TAG_DIALOG";
export const CLOSE_TAG_DIALOG = "CLOSE_TAG_DIALOG";
